module.exports = __webpack_public_path__ + "static/img/6.9dfdbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/4/6.png
// module id = YOAi
// module chunks = 0